import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from "eduid-hooks";
import { FormattedMessage } from "react-intl";
/**
 * Show information about where the user is about to log in (source: MDUI display name from federation metadata)
 */
export function LoginAtServiceInfo({ service_info }) {
    const locale = useAppSelector((state) => state.intl.locale);
    let service_name;
    if (!(service_info === null || service_info === void 0 ? void 0 : service_info.display_name)) {
        return null;
    }
    if (service_info.display_name[locale]) {
        service_name = service_info.display_name[locale];
    }
    else {
        service_name = service_info.display_name["en"];
    }
    if (!service_name) {
        return null;
    }
    return (_jsx("p", { children: _jsx(FormattedMessage, { id: "atServiceInfo.use", defaultMessage: "Use eduID to access {service_name}", values: {
                service_name: _jsx("strong", { children: service_name }),
            } }) }));
}
